var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgCompramos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "88px",
    viewBox: "0 0 100 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.471222137
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Sigrotal_Home_Claro",
    transform: "translate(-1699.000000, -2477.000000)",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51-Copy-2",
    transform: "translate(1381.000000, 2328.999990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.56539,205.524534 L416.452547,234.062128 L382.838073,234.511562 L366.184798,205.97034 L399.56539,205.524534 Z M356.467763,205.531999 L359.623766,205.532873 L361.106617,205.533839 L362.162721,205.534799 L363.162288,205.535963 C364.778553,205.538076 366.128687,205.54105 367.065006,205.54497 L370.933988,205.580026 C369.245682,208.724286 367.843432,211.121991 366.440928,213.519695 L354.166805,234.5 L320.388468,234.5 L336.695204,206.5451 C337.16825,206.010746 340.889163,205.545225 346.368056,205.537984 L347.123716,205.537037 C347.505969,205.536583 347.894521,205.536159 348.288221,205.535765 L349.081844,205.535017 L350.292716,205.534047 L351.933952,205.533041 L355.241244,205.532029 L356.467763,205.531999 Z M368.528921,151.044815 L385.810753,180.474922 C384.566325,182.60858 383.317647,184.735935 382.069522,186.862346 C381.441254,187.932715 380.813127,189.002845 380.18535,190.074109 L368.725334,209.606099 L367.364684,207.888592 C367.343801,207.862232 367.207571,207.660481 366.986184,207.293853 L366.609682,206.667159 C365.47388,204.770348 362.990888,200.584984 360.370709,196.157627 L359.956261,195.457245 C357.048709,190.543134 354.05143,185.465114 352.594548,182.980324 L351.386088,180.898606 C351.520112,180.411973 351.598932,180.132091 351.609736,180.106106 C351.658635,179.988505 354.412378,175.215797 357.609656,169.712071 L357.973386,169.086096 C358.216973,168.666978 358.4626,168.24454 358.709296,167.820468 L359.108718,167.133936 L359.709093,166.102285 L360.108799,165.41564 C362.304494,161.644137 364.431296,157.997917 365.784546,155.688321 L368.528921,151.044815 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCompramos);
export default __webpack_public_path__ + "static/media/svg_compramos.b958a902ef8ee744185964a13fb021df.svg";
export { ForwardRef as ReactComponent };